import $ from 'jquery';
import * as lightbox from '../../home24/helpers/lightbox';

var selector = '#contact-message-box';
var $html = $(selector);

if ($html.length > 0) {
    lightbox.setConfig({
        $dialog: $html,
        className: 'contact-message-box'
    }).open();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/contactFormMessage.js
 **/